import { Smartphone, Users, Wallet /*LineChart */ } from "lucide-react";
import crowdfund from "../assets/CrowdFund-ScreenShoot.png";
import crowdfundRw from "../assets/CrowdFund-ScreenShootRW.png";
import crowdfundWorkflow from "../assets/crowdfund-workflow.png";
import ikimina from "../assets/Ikimina-ScreenShoot.png";
import ikiminaRw from "../assets/Ikimina-ScreenShootRW.png";
import ikiminaWorkflow from "../assets/ikimina-workflow.png";
import uSave from "../assets/USave-ScreenShoot.png";
import uSaveRw from "../assets/USave-ScreenShootRW.png";

export const products = ["crowdfund", "group-saving", "u-save" /*"u-invest*/];
export const solutions = [
  {
    id: "crowdfund",
    title: "Social CrowdFund",
    description: "crowdFund_description",
    icon: <Users className="w-5 h-5" />,
  },
  {
    id: "group-saving",
    title: "Group Saving (IKIMINA)",
    description: "ikimina_description",
    icon: <Wallet className="w-5 h-5" />,
  },
  {
    id: "u-save",
    title: "U-Save",
    description: "iSavings_description",
    icon: <Smartphone className="w-5 h-5" />,
  },
];
// {
//   id: "u-invest",
//   title: "U-Invest",
//   description: "uInvest_description",
//   icon: <LineChart className="w-5 h-5" />,
// },

export const productsInformation = {
  crowdfund: {
    name: "Social Crowdfunding",
    description: {
      title: (
        <span>
          With Social Crowdfunding
          <br />
          Fund Life's Big Moments
        </span>
      ),
      content:
        "From weddings to birthdays to medical needs, raise funds easily and securely with Uplus. Invite friends, track contributions, and reach your goals faster than ever.",
    },
    images: {
      heroImage: {
        en: crowdfund,
        rw: crowdfundRw,
      },
      workflowImage: {
        en: crowdfundWorkflow,
        rw: crowdfundWorkflow,
      },
    },

    benefits: {
      title: "Built for your success, powered by your community.",
      content: [
        {
          title: "Start for Free",
          description:
            "Create your campaign at no cost. We only take a tiny fee from successful contributions, so you keep more of what you raise.",
        },
        {
          title: "Raise Funds for Any Cause",
          description:
            "Whether it's a wedding, medical emergency, birthday, graduation, or school fees, our platform supports all personal fundraising needs.",
        },
        {
          title: "Get Funds Instantly anytime",
          description:
            "No waiting weeks to access your money, withdraw your contributions to your Mobile Money anytime.",
        },
        {
          title: "Easy to Share, Easy to Support",
          description:
            "We give you a free USSD code for your campaign to share anyone via WhatsApp, social media, or SMS in just one tap. Your friends and family can support from anywhere.",
        },
        {
          title: "Transparent & Secure Contributions",
          description:
            "Every contribution is tracked. Supporters get real-time updates, and you get full control over how funds are collected and used.",
        },
        {
          title: "Build Trust with Updates",
          description:
            "Keep your supporters engaged with regular updates, thank-you messages, and progress reports—right from the app. It’s your story, and your community is part of it.",
        },
      ],
    },

    workflow: {
      title:
        "Start your campaign in minutes and begin raising funds effortlessly.",
      content: [
        {
          step: "Set Up Your Campaign",
          description:
            "Create a Social Crowdfunding Group, describe your cause, set your target amount, and add photos to help supporters connect with your story.",
        },
        {
          step: "Share with Your Network",
          description:
            "Get the word out instantly! Share your campaign via WhatsApp, SMS, social media, or an invitation to your group so that friends and family can contribute.",
        },
        {
          step: "Track Contributions in Real-Time",
          description:
            "Monitor progress as Contributions come in. You'll get notified each time someone contributes and so will they!",
        },
        {
          step: "Withdraw Funds Anytime",
          description:
            "Withdraw to your mobile wallet whenever you're ready. It's fast, secure, and always in your control.",
        },
      ],
    },

    faqs: [
      {
        question: "Is it free to start a crowdfunding campaign?",
        answer:
          "Yes! Creating a campaign is completely free. We only deduct a small service fee of 1% from each contribution to cover secure payment processing.",
      },
      {
        question:
          "How do I receive the money people contribute to my campaign?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "Can people from other countries contribute to my campaign?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "What kinds of campaigns are allowed?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "Is my data and money safe?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
    ],
  },
  "u-save": {
    name: "U-Save",
    description: {
      title: `Save Smarter, 
Reach Your Goals Faster.`,
      content:
        "Whether you're saving for a trip, school, or emergency fund, U-Save makes it easy to stay on track. Set your target, save at your pace, and watch your money grow.",
    },
    images: {
      heroImage: {
        en: uSave,
        rw: uSaveRw,
      },
      workflowImage: {
        en: crowdfundWorkflow,
        rw: crowdfundWorkflow,
      },
    },

    benefits: {
      title: "Built for your success, powered by your community.",
      content: [
        {
          title: "Set Multiple Goals",
          description:
            "Save for travel, emergencies, rent, education and manage it all in one app.",
        },
        {
          title: "Safe & Secure",
          description:
            "Your savings are protected with encrypted transactions and verified accounts.",
        },
        {
          title: "Smart Reminders",
          description:
            "Get friendly reminders and motivational messages to keep you on track.",
        },
        {
          title: "Savings History Reports",
          description:
            "Track how much you've saved over time with downloadable transaction History.",
        },
        {
          title: "Lock SAVINGS for Discipline",
          description:
            "Temporarily lock specific savings goals to reduce impulse withdrawals and build discipline.",
        },
        {
          title: "Goal Sharing for Accountability",
          description:
            "Proud of your savings streak? Share your achievements with friends or flex them on social media. Inspire others while keeping yourself motivated and accountable!",
        },
      ],
    },

    workflow: {
      title: "Saving Made Simple, Here's How:",
      content: [
        {
          step: "Create a Savings Goal",
          description:
            "Give your goal a name, set the target amount, and choose how often you want to save.",
        },
        {
          step: "Top Up Anytime You Like",
          description:
            "You're in control. Deposit money manually into your savings goal whenever it's convenient daily, weekly,monthly, or randomly.",
        },
        {
          step: "Track Your Progress in Real-Time",
          description:
            "Watch your savings grow with visual goal trackers and milestone badges.",
        },
        {
          step: "Celebrate When You Hit Your Goal",
          description:
            "Once your target is reached, you can withdraw your savings and treat yourself to your goal. You did it no penalties, no surprises.",
        },
      ],
    },

    faqs: [
      {
        question: "Is there a minimum amount I need to save?",
        answer:
          "No. You can start with any amount that works for you. even small amounts add up!",
      },
      {
        question: "Can I create more than one goal at a time?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "What happens if I miss a scheduled save?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "Can I change my goal amount or deadline later?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "How do I withdraw my savings?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
    ],
  },
  "group-saving": {
    name: "Group Saving (IKIMINA)",
    description: {
      title: "Save as a Group & Earn More",
      content:
        "Save together with friends or family, borrow when needed, and earn shared interest at the end of each cycle. Group Savings and Loans made easy.",
    },
    images: {
      heroImage: {
        en: ikimina,
        rw: ikiminaRw,
      },
      workflowImage: {
        en: ikiminaWorkflow,
        rw: ikiminaWorkflow,
      },
    },

    benefits: {
      title:
        "Here are powerful benefits that make users trust and love this product:",
      content: [
        {
          title: "Save Together & Grow Faster",
          description:
            "Pooling savings as a group helps members reach financial goals quicker than saving alone.",
        },
        {
          title: "Easy Loan Requests & Approvals",
          description:
            "Members can request loans with one tap. Group admins receive a notification and approve instantly.",
        },
        {
          title: "Fair, Transparent Lending Rules",
          description:
            "Set loan limits, repayment deadlines, and interest rates so everyone participates with clarity and trust.",
        },
        {
          title: "Works for Any Group Size",
          description:
            "Whether it's 3 people or 300, the app keeps everything in order contribution history, interest earned, loan history, and payouts.",
        },
        {
          title: "Earn Interest From Group Loans",
          description:
            "The money loaned out within the group generates interest and all members share the earnings at the end of the cycle.",
        },
        {
          title: "Strengthen Community & Trust",
          description:
            "Perfect for families, co-workers, friends, and community groups wanting a transparent financial structure.",
        },
      ],
    },

    workflow: {
      title: "Saving Made Simple, Here's How:",
      content: [
        {
          step: "Create a Group",
          description:
            "Start a new group by choosing a name, description, and savings cycle length. You can set rules like contribution amount and interest rate for loans.",
        },
        {
          step: "Invite Members",
          description:
            "Invite by adding members manually through your contacts. Members will receive the invite and join the group in seconds.",
        },
        {
          step: "Start Saving Together",
          description:
            "Each member contributes manually at the agreed schedule (daily, weekly, or monthly). The app records all contributions automatically.",
        },
        {
          step: "Request & Approve Loans",
          description:
            "Members can request a loan from the pooled funds. Group treasures receive a notification and approve or decline instantly. Loan repayments + interest go back to the group pool.",
        },
        {
          step: "Track Everything in Real Time",
          description:
            "View contributions, loan requests, outstanding loans, repayments, and group earnings in one place.",
        },
        {
          step: "Withdraw Savings + Earned Interest",
          description:
            "At the end of the cycle, members withdraw their total contributions plus their share of interest earned from issued loans.",
        },
      ],
    },

    faqs: [
      {
        question: "Is there a minimum amount I need to save?",
        answer:
          "No. You can start with any amount that works for you. even small amounts add up!",
      },
      {
        question: "Can I create more than one goal at a time?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "What happens if I miss a scheduled save?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "Can I change my goal amount or deadline later?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "How do I withdraw my savings?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "Is my money safe in the app?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
      {
        question: "How will I know when I have reached my target?",
        answer:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, fuga debitis deserunt inventore quidem iure. Corporis aperiam excepturi possimus! Repellendus!",
      },
    ],
  },
};
